// src/api/authApi.ts
// Authentication API endpoints

import { baseApi } from './baseApi';

export interface AuthUser {
  id: string;
  email: string;
  fullName: string | null;
  displayName: string | null;
  avatarUrl: string | null;
  activeWorkspaceId: string | null;
  workspaceName: string | null;
  role: string | null;
}

export interface AuthResponse {
  token: string;
  user: AuthUser;
}

export interface LoginRequest {
  email: string;
  password?: string;
}

export interface DevLoginRequest {
  email?: string;
}

export interface CurrentUserResponse {
  user: AuthUser;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Standard login
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),

    // Dev login (creates user if needed)
    devLogin: builder.mutation<AuthResponse, DevLoginRequest>({
      query: (body) => ({
        url: '/auth/dev-login',
        method: 'POST',
        body,
      }),
    }),

    // Get current authenticated user
    getCurrentUser: builder.query<CurrentUserResponse, void>({
      query: () => '/auth/me',
    }),

    // Logout
    logout: builder.mutation<{ success: boolean }, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useDevLoginMutation,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useLogoutMutation,
} = authApi;
